import { get } from 'lodash'

const state = {
  contractListCurrentPage: 1,
  contractPageListStore: {},
  contractListLastId: '',
  contractSearchCriteria: {
    refCode: '',
    hotelId: '',
    agentId: '',
    agentIdList: [],
    contractValid: '',
    salePersonId: '',
    status: '',
    marketId: ''
  }
}

const getters = {}

const actions = {
  clearMapStateContractList (context) {
    const contractSearchCriteria = {
      refCode: '',
      hotelId: '',
      agentId: '',
      agentIdList: [],
      contractValid: '',
      salePersonId: '',
      status: '',
      marketId: ''
    }

    context.commit('setContractSearchCriteria', contractSearchCriteria)
    context.commit('setContractListCurrentPage', 1)
    context.commit('setContractPageListStore', {})
  },
  setContractSearchCriteria (context, payLoad) {
    context.commit('setContractSearchCriteria', payLoad)
  },
  setContractListCurrentPage (context, payLoad) {
    context.commit('setContractListCurrentPage', payLoad)
  },
  setContractListLastId (context, payLoad) {
    context.commit('setContractListLastId', payLoad)
  },
  setContractPageListStore (context, payLoad) {
    context.commit('setContractPageListStore', payLoad)
  },
  updateContractPageListStore (context, payLoad) {
    const pageNumber = payLoad.pageNumber

    if (pageNumber === 1) {
      return
    }

    const contractDetail = payLoad.contractDetail
    const contractPageListStore = context.state.contractPageListStore
    const contractSelectedPageList = contractPageListStore[pageNumber]
    const contractIndex = contractSelectedPageList.findIndex(contract => contract.id === contractDetail.id)

    contractSelectedPageList[contractIndex] = _prepareContractListUpdateData(contractDetail)
    context.commit('setContractPageListStore', contractPageListStore)
  }
}

const mutations = {
  setContractSearchCriteria (state, payLoad) {
    state.contractSearchCriteria = payLoad
  },
  setContractListCurrentPage (state, payLoad) {
    state.contractListCurrentPage = payLoad
  },
  setContractPageListStore (state, payLoad) {
    state.contractPageListStore = payLoad
  },
  setContractListLastId (state, payLoad) {
    state.contractListLastId = payLoad
  }
}

const _prepareContractListUpdateData = (contractDetail) => {
  const salePersonTitle = get(contractDetail, 'salePerson.title', '')
  const salePersonFirstName = get(contractDetail, 'salePerson.firstName', '')
  const salePersonLastName = get(contractDetail, 'salePerson.lastName', '')
  const salePersonName = `${salePersonTitle} ${salePersonFirstName} ${salePersonLastName}`

  const contractData = {
    id: contractDetail.id,
    hotelId: contractDetail.hotelId,
    agentId: get(contractDetail, 'agent.id', ''),
    agentName: get(contractDetail, 'agent.name', ''),
    salePersonId: get(contractDetail, 'salePerson.id', ''),
    salePersonName: salePersonName,
    refCode: contractDetail.refCode.toUpperCase(),
    startDate: new Date(contractDetail.startDate),
    endDate: new Date(contractDetail.endDate),
    status: contractDetail.status,
    updatedAt: new Date()
  }

  return contractData
}

export default {
  name: 'contract',
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
